import { createRoot } from 'react-dom/client';
import { Provider as StoreProvider } from 'react-redux';
import { Auth0Provider } from '@auth0/auth0-react';
import App from './App';
import { store } from './store';
import './utils/welcome';
import './styles/index.scss';
import {
  AUTH0_AUDIENCE,
  AUTH0_CACHE_LOCATION,
  AUTH0_CLIENT_ID,
  AUTH0_DOMAIN,
  AUTH0_SCOPE,
} from './utils/auth0/constants';

const root = createRoot(document.getElementById('root') as HTMLElement);

root.render(
  <Auth0Provider
    domain={AUTH0_DOMAIN}
    clientId={AUTH0_CLIENT_ID}
    cacheLocation={AUTH0_CACHE_LOCATION}
    useRefreshTokens
    authorizationParams={{
      redirect_uri: window.location.origin,
      scope: AUTH0_SCOPE,
      audience: AUTH0_AUDIENCE,
    }}
  >
    <StoreProvider store={store}>
      <App />
    </StoreProvider>
  </Auth0Provider>,
);
